(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixelarc-archive-cards"] && !Shopify.designMode) return;
  try {
    
/* Pixel Arc Archives: native full-quality video, no dependencies or tracking. */
(() => {
  const tagName = 'pa-hologram-archives';
  if (customElements.get(tagName)) return;

  class PixelArcArchives extends HTMLElement {
    connectedCallback() {
      this._setupFrame = requestAnimationFrame(() => {
        if (this.isConnected) this._setup();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._setupFrame);
      cancelAnimationFrame(this._layoutFrame);
      this._events?.abort();
      this._resize?.disconnect();
      this._intersection?.disconnect();
      this._prewarm?.disconnect();
      this._suspend();
      this._events = null;
    }

    _setup() {
      if (this._events) return;
      this._events = new AbortController();
      const signal = this._events.signal;
      this._mobile = matchMedia('(max-width: 749px)');
      this._pageHidden = false;
      this._lastWake = -Infinity;
      this._records = [];

      this.querySelectorAll('.pa-ha__video').forEach((video) => {
        const card = video.closest('[data-pa-card]');
        const media = video.closest('.pa-ha__media');
        const record = {
          video, card, media, signal, ended: false, pending: false,
          token: 0, active: false, blocked: false, failed: false,
          reloads: 0, lastReload: -Infinity, retryAt: 0, frameId: null,
          resumeTime: null, warmed: false, preload: video.preload
        };
        this._measure(record);
        this._records.push(record);
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.disablePictureInPicture = true;
        video.loop = card.dataset.loop === 'true';
        video.setAttribute('aria-hidden', 'true');
        video.tabIndex = -1;

        const prepare = () => {
          if (signal.aborted) return;
          const speed = Number(card.dataset.speed) / 100;
          video.playbackRate = Number.isFinite(speed) ? Math.max(.25, Math.min(2, speed)) : 1;
          const start = record.resumeTime ?? Math.max(0, Number(card.dataset.start) || 0);
          if (start > 0 && Number.isFinite(video.duration)) {
            try { video.currentTime = Math.min(start, Math.max(0, video.duration - .1)); } catch (_) { /* Retry after data arrives. */ }
          }
          record.resumeTime = null;
          this._updateVideo(record);
        };
        video.addEventListener('loadedmetadata', prepare, { signal });
        video.addEventListener('playing', () => {
          record.pending = false;
          record.needsGesture = false;
          media.classList.remove('is-starting');
          if (this._wantsPlayback(record)) {
            // Reveal on playing so an invisible surface cannot defer its first frame callback.
            media.classList.add('is-playing');
            this._sampleFrame(record);
          }
          // Playback may begin after a tab switch or a preference change.
          this._updateVideo(record);
        }, { signal });
        video.addEventListener('canplay', () => this._updateVideo(record), { signal });
        video.addEventListener('ended', () => {
          if (!video.loop) record.ended = true;
          this._updateVideo(record);
        }, { signal });
        video.addEventListener('error', () => {
          record.failed = true;
          record.needsGesture = true;
          record.pending = false;
          record.token++;
          media.classList.remove('is-playing');
          media.classList.remove('is-starting');
          this._ensureWatch();
        }, { signal });
        if (video.readyState >= 1) prepare();
      });

      if ('IntersectionObserver' in window && this._records.length) {
        const byMedia = new Map(this._records.map((record) => [record.media, record]));
        this._intersection = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const record = byMedia.get(entry.target);
            record.visible = entry.isIntersecting && entry.intersectionRatio > 0;
            this._updateVideo(record);
          });
        }, { threshold: [0, .01] });
        this._prewarm = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const record = byMedia.get(entry.target);
            record.near = entry.isIntersecting;
            this._warmVideo(record);
          });
        }, { rootMargin: '500px 0px', threshold: 0 });
        this._records.forEach(({ media }) => {
          this._intersection.observe(media);
          this._prewarm.observe(media);
        });
      } else {
        // Older browsers still refresh viewport eligibility when scrolling.
        window.addEventListener('scroll', () => {
          if (this._scrollFrame) return;
          this._scrollFrame = requestAnimationFrame(() => {
            this._scrollFrame = null;
            if (signal.aborted) return;
            this._records.forEach((record) => this._measure(record));
            this._updatePlayback();
          });
        }, { passive: true, signal });
      }

      // Retry browser-blocked playback on an ordinary touch, without adding controls.
      const retryPlayback = () => this._retryFromGesture();
      document.addEventListener('pointerup', retryPlayback, { passive: true, signal });
      document.addEventListener('touchend', retryPlayback, { passive: true, signal });
      document.addEventListener('click', retryPlayback, { signal });
      document.addEventListener('keydown', retryPlayback, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._suspend();
        else this._wake();
      }, { signal });
      window.addEventListener('pagehide', () => this._suspend(), { signal });
      window.addEventListener('pageshow', () => { this._scheduleLayout(); this._wake(); }, { signal });
      window.addEventListener('focus', () => this._wake(), { signal });
      window.addEventListener('online', () => this._wake(true), { signal });
      this._mobile.addEventListener('change', () => { this._scheduleLayout(); this._wake(true); }, { signal });

      if ('ResizeObserver' in window) {
        let previousWidth = -1;
        this._resize = new ResizeObserver((entries) => {
          const width = entries[0]?.contentRect.width || 0;
          if (Math.abs(width - previousWidth) > .1) {
            previousWidth = width;
            this._scheduleLayout();
            this._records.forEach((record) => this._measure(record));
            this._updatePlayback();
          }
        });
        this._resize.observe(this.querySelector('.pa-ha__grid') || this);
      }
      window.addEventListener('resize', () => {
        this._scheduleLayout();
        this._records.forEach((record) => this._measure(record));
        this._updatePlayback();
      }, { passive: true, signal });
      if (document.fonts) {
        document.fonts.ready.then(() => { if (!signal.aborted) this._scheduleLayout(); });
        document.fonts.addEventListener('loadingdone', () => this._scheduleLayout(), { signal });
      }
      if (this.dataset.editor === 'true') {
        this.addEventListener('click', (event) => {
          if (event.target.closest('a.pa-ha__card')) event.preventDefault();
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          if (event.target.matches('[data-pa-settings-marker]')) {
            this.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }
          this._scheduleLayout();
        }, { signal });
      }
      this._scheduleLayout();
      this._updatePlayback();
    }

    _updatePlayback() {
      if (!this.isConnected || !this._records) return;
      this._records.forEach((record) => this._updateVideo(record));
    }

    _retryFromGesture() {
      this._records.forEach((record) => {
        this._measure(record);
        if (!this._wantsPlayback(record) || record.failed) return;
        const stalled = record.active && performance.now() - record.lastProgress >= 2500;
        if (!record.blocked && !record.needsGesture && !record.video.paused && !stalled) return;
        this._pauseVideo(record);
        record.blocked = false;
        record.needsGesture = false;
        record.retryAt = 0;
        this._updateVideo(record); // Keep play() synchronous with the gesture.
      });
    }

    _measure(record) {
      const rect = record.media.getBoundingClientRect();
      const displayed = rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < innerWidth;
      record.visible = displayed && rect.bottom > 0 && rect.top < innerHeight;
      record.near = displayed && rect.bottom > -500 && rect.top < innerHeight + 500;
    }

    _posterOnly(record) {
      return record.card.dataset.autoplay !== 'true' ||
        (this._mobile.matches && record.card.dataset.stillMobile === 'true');
    }

    _wantsPlayback(record) {
      return this.isConnected && !record.signal.aborted && !document.hidden && !this._pageHidden &&
        !this._posterOnly(record) && !record.ended &&
        !!record.card.getClientRects().length &&
        (this.dataset.pauseOffscreen !== 'true' || record.visible);
    }

    _warmVideo(record) {
      if (record.warmed || !record.near || record.preload === 'none' || document.hidden ||
          this._pageHidden || this._posterOnly(record)) return;
      record.warmed = true;
      // Keep the same Shopify sources and buffer; do not call load() here.
      record.video.preload = 'auto';
      record.video.setAttribute('loading', 'eager');
      const poster = record.media.querySelector('.pa-ha__poster');
      if (poster) poster.loading = 'eager';
    }

    _pauseVideo(record) {
      record.token++; // Ignore promises from an earlier play request.
      record.pending = false;
      record.active = false;
      record.video.autoplay = false;
      record.media.classList.remove('is-starting');
      record.healthySince = null;
      if (record.frameId !== null) {
        record.video.cancelVideoFrameCallback?.(record.frameId);
        record.frameId = null;
      }
      if (!record.video.paused) record.video.pause();
    }

    _suspend() {
      this._pageHidden = true;
      clearTimeout(this._watchTimer);
      this._watchTimer = null;
      cancelAnimationFrame(this._scrollFrame);
      this._scrollFrame = null;
      this._records?.forEach((record) => this._pauseVideo(record));
    }

    _wake(force = false) {
      if (!this.isConnected || this._events?.signal.aborted || document.hidden) return;
      const now = performance.now();
      if (!force && !this._pageHidden && now - this._lastWake < 750) return;
      this._lastWake = now;
      this._pageHidden = false;
      this._records.forEach((record) => {
        this._measure(record); // IntersectionObserver can be stale after back/forward navigation.
        record.blocked = false;
        record.retryAt = 0;
        record.reloads = 0;
        if (record.pending || record.video.paused || record.failed) this._pauseVideo(record);
      });
      this._updatePlayback();
    }

    _updateVideo(record) {
      if (record.signal.aborted) return;
      const { video, media } = record;
      media.classList.toggle('is-static', this._posterOnly(record));
      this._warmVideo(record);
      if (!this._wantsPlayback(record)) { this._pauseVideo(record); return; }
      const now = performance.now();
      if (!record.active) {
        record.active = true;
        record.lastProgress = now;
        record.lastTime = video.currentTime;
        record.bufferedEnd = video.buffered.length ? video.buffered.end(video.buffered.length - 1) : 0;
        record.lastBufferProgress = now;
        record.softRetried = false;
      }
      this._ensureWatch();
      if (record.failed || record.blocked || now < record.retryAt) return;
      this._sampleFrame(record);
      // A theme script may already have started a cached video before our listeners.
      // Configure and reveal the surface even when the element is already unpaused.
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.autoplay = true;
      if (!media.classList.contains('is-playing')) media.classList.add('is-starting');
      if (record.pending || !video.paused) return;
      video.preload = 'auto';
      video.setAttribute('loading', 'eager');
      record.pending = true;
      const token = ++record.token;
      const settled = (error) => {
        if (record.signal.aborted || token !== record.token) return;
        record.pending = false;
        if (error) {
          if (error.name === 'NotAllowedError') { record.blocked = true; record.needsGesture = true; }
          else if (error.name === 'NotSupportedError') record.failed = true;
          record.retryAt = performance.now() + 1000;
          media.classList.remove('is-playing');
          media.classList.remove('is-starting');
        }
        if (!this._wantsPlayback(record)) this._pauseVideo(record);
      };
      try {
        const result = video.play();
        if (result && typeof result.then === 'function') result.then(() => settled(), settled);
        else settled();
      } catch (error) { settled(error); }
    }

    _sampleFrame(record) {
      const video = record.video;
      // At most one callback per video per watchdog tick, not a per-frame JS loop.
      if (record.frameId !== null || typeof video.requestVideoFrameCallback !== 'function') return;
      record.frameId = video.requestVideoFrameCallback(() => {
        record.frameId = null;
        if (record.signal.aborted || !record.active || !this._wantsPlayback(record)) return;
        this._markProgress(record, performance.now());
        record.media.classList.add('is-playing');
      });
    }

    _markProgress(record, now) {
      record.lastProgress = now;
      record.lastTime = record.video.currentTime;
      record.needsGesture = false;
      record.softRetried = false;
      record.healthySince ??= now;
      // Replenish the retry budget only after sustained, confirmed playback.
      if (now - record.healthySince >= 10000) record.reloads = 0;
    }

    _ensureWatch() {
      if (this._watchTimer || document.hidden || this._pageHidden || !this.isConnected) return;
      if (!this._records.some((record) => record.active && record.visible && !record.blocked && (!record.failed || record.reloads < 2))) return;
      this._watchTimer = setTimeout(() => {
        this._watchTimer = null;
        this._checkPlayback();
      }, 1000);
    }

    _checkPlayback() {
      const now = performance.now();
      this._records.forEach((record) => {
        if (!record.active || !record.visible || record.blocked || !this._wantsPlayback(record)) return;
        const video = record.video;
        if (typeof video.requestVideoFrameCallback !== 'function' && Math.abs(video.currentTime - record.lastTime) > .01) {
          this._markProgress(record, now);
          record.media.classList.add('is-playing');
        }
        this._sampleFrame(record);
        const bufferedEnd = video.buffered.length ? video.buffered.end(video.buffered.length - 1) : 0;
        if (bufferedEnd > record.bufferedEnd + .05) record.lastBufferProgress = now;
        record.bufferedEnd = bufferedEnd;
        const stalledFor = now - record.lastProgress;
        if (stalledFor >= 2500) {
          record.healthySince = null;
          record.needsGesture = true;
        }
        if (record.failed) {
          this._reloadVideo(record, now);
        } else if (stalledFor >= 2500 && !record.softRetried) {
          // A lightweight pause/play also releases a play promise stuck in the background.
          this._pauseVideo(record);
          record.active = true;
          record.softRetried = true;
          record.retryAt = 0;
          this._updateVideo(record);
        } else if (stalledFor >= 5500) {
          this._reloadVideo(record, now);
        } else if (video.paused && !record.pending) {
          this._updateVideo(record);
        }
      });
      this._ensureWatch();
    }

    _reloadVideo(record, now) {
      const video = record.video;
      // Give an insufficient but growing buffer time to load without restarting it.
      if (!record.failed && video.readyState < 3 && now - record.lastBufferProgress < 6000) return;
      if (record.reloads >= 2 || now - record.lastReload < 12000 || navigator.onLine === false) return;
      this._pauseVideo(record);
      record.resumeTime = Number.isFinite(video.currentTime) && video.currentTime > 0
        ? video.currentTime : Math.max(0, Number(record.card.dataset.start) || 0);
      record.reloads++;
      record.lastReload = now;
      record.lastProgress = now;
      record.bufferedEnd = 0;
      record.lastBufferProgress = now;
      record.failed = false;
      record.retryAt = 0;
      record.media.classList.remove('is-playing');
      // Same URL permits browser/CDN caching. No cache-busters or quality changes.
      video.load();
      this._updateVideo(record);
    }

    _scheduleLayout() {
      cancelAnimationFrame(this._layoutFrame);
      this._layoutFrame = requestAnimationFrame(() => {
        if (this.isConnected) this._balance();
      });
    }

    _balance() {
      const allCards = [...this.querySelectorAll('[data-pa-card]')];
      allCards.forEach((card) => {
        card.querySelectorAll('[data-ha-slot]').forEach((slot) => { slot.style.minHeight = ''; });
        const title = card.querySelector('.pa-ha__title');
        if (title) title.style.fontSize = '';
        card.removeAttribute('data-ha-has-title');
      });
      const cards = allCards.filter((card) => card.getClientRects().length && card.clientWidth > 0);
      if (!cards.length) return;

      if (this.dataset.singleLine === 'true' && this.dataset.fitTitles === 'true') {
        const titleData = cards.map((card) => {
          const title = card.querySelector('.pa-ha__title');
          if (!title) return null;
          const base = parseFloat(getComputedStyle(title).fontSize);
          const content = title.querySelector('span');
          const width = content?.getBoundingClientRect().width || 0;
          const minimum = Math.min(base, Number(this.dataset.titleMin) || 10);
          const available = Math.max(1, title.clientWidth - .5);
          const fit = width > available ? Math.max(minimum, base * available / width - .04) : base;
          return { title, fit };
        }).filter(Boolean);
        const shared = titleData.length ? Math.min(...titleData.map((item) => item.fit)) : 0;
        titleData.forEach(({ title, fit }) => {
          const size = this.dataset.syncTitles === 'true' ? shared : fit;
          title.style.fontSize = `${Math.floor(size * 100) / 100}px`;
        });
      }

      if (this.dataset.alignText !== 'true') return;
      // Only align cards that share a grid row. Stacked mobile cards stay natural.
      const rows = [];
      cards.forEach((card) => {
        const top = card.getBoundingClientRect().top;
        let row = rows.find((item) => Math.abs(item.top - top) < 2);
        if (!row) { row = { top, cards: [] }; rows.push(row); }
        row.cards.push(card);
      });
      rows.forEach(({ cards: rowCards }) => {
        if (rowCards.length < 2) return;
        const hasTitle = rowCards.some((card) => card.querySelector('.pa-ha__title'));
        rowCards.forEach((card) => { card.dataset.haHasTitle = String(hasTitle); });
        const selectors = [
          ['media', '.pa-ha__media'],
          ['title', '.pa-ha__title'],
          ['description', '.pa-ha__description']
        ];
        selectors.forEach(([slotName, childSelector]) => {
          const heights = rowCards.map((card) => {
            const child = card.querySelector(childSelector);
            if (!child) return 0;
            const style = getComputedStyle(child);
            return child.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
          });
          const height = Math.ceil(Math.max(0, ...heights));
          rowCards.forEach((card) => {
            const slot = card.querySelector(`[data-ha-slot="${slotName}"]`);
            if (slot) slot.style.minHeight = `${height}px`;
          });
        });
      });
    }
  }
  customElements.define(tagName, PixelArcArchives);
})();


  } catch(e) { console.error(e); }
})();
})();
